export class Ocupacion {

    id: String;
    descripcion: String;

    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/models/tipo/ocupacion.class.ts